import React,{ useEffect, useRef, useState } from "react";
import DashboardLayout from "../../DashboardLayout";
import { Button, Form } from "react-bootstrap";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import { fetchAdsCountByAdsPlacement } from "../../../services/axios/apiManager";
import { handleErrors } from "../../../services/dataManager";
import { useNavigate } from "react-router-dom";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import LoadingSpinner from "../../../Components/spinner";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

function AdPlacementPerformance() {
  const tableRef = useRef(null);
  const navigation = useNavigate();
  const [selectedPlacement, setSelectedPlacement] = useState("");
  const [tableData, setTableData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [fetching, setFetching] = useState(true);

  const getAdsCountByAdsPlacement = async () => {
    const res = await fetchAdsCountByAdsPlacement();
    if (res?.data?.success && res?.data?.data) {
      setTableData(res.data.data);
      if (selectedPlacement?.length) {
        const temp = res?.data?.data?.filter(
          (f) => f.ad_placement === selectedPlacement
        );
        setFilteredData(temp);
      } else {
        setFilteredData(res.data.data);
      }
    } else {
      handleErrors(res, navigation);
    }
    setFetching(false);
  };

  const handleFilterChange = (str) => {
    setSelectedPlacement(str);
    if (str?.length) {
      const temp = tableData.filter((f) => f.ad_placement === str);
      setFilteredData(temp);
    } else {
      setFilteredData(tableData);
    }
  };

  const handleReset = () => {
    setSelectedPlacement("");
    setFilteredData(tableData);
  };

  const chartData = {
    labels: filteredData.map((item) => item.ad_placement),
    datasets: [
      {
        label: "Ads Played",
        data: filteredData.map((item) => item.total_ads),
        backgroundColor: "rgba(75, 192, 192, 0.7)",
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        labels: { color: "#ffffff" },
      },
    },
    scales: {
      x: { ticks: { color: "#ffffff" } },
      y: { beginAtZero: true, ticks: { color: "#ffffff" } },
    },
  };

  useEffect(() => {
    getAdsCountByAdsPlacement();
  }, []);

  useEffect(() => {
    const $table = $(tableRef.current);
    const rows = filteredData.map((item) => {
      return [item?.ad_placement, item?.total_ads];
    });
    const config = {
      data: rows,
      columns: [{ title: "Ad Placement" }, { title: "Total Ads" }],
      destroy: true,
      responsive: true,
      paging: false,
      searching: false,
    };
    if ($.fn.dataTable.isDataTable(tableRef.current)) {
      $table.DataTable().clear().rows.add(rows).draw();
    } else {
      $table.DataTable(config);
    }
    return () => {
      if ($.fn.dataTable.isDataTable(tableRef.current)) {
        $table.DataTable().destroy();
      }
    };
  }, [filteredData]);

  return (
    <DashboardLayout>
      {/* Filter Card Without Tabs */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h5 className="card-title">Filter by Ad Placement</h5>
          <div className="row align-items-center mb-3">
            <div className="col-md-3">
              <Form.Select
                className="bg-dark text-light border-light"
                value={selectedPlacement}
                onChange={(e) => handleFilterChange(e.target.value)}
              >
                <option value="">All ad placements</option>
                {tableData?.map((m) => (
                  <option value={m.ad_placement}>{m.ad_placement}</option>
                ))}
              </Form.Select>
            </div>
            <div className="col-md-2">
              {fetching ? (
                <LoadingSpinner size={"small"} />
              ) : (
                <Button className="btn btn-success" onClick={handleReset}>
                  Reset
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Table Card */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h5 className="card-title">Ad Placement Performance</h5>
          <p className="card-text">
            Compare revenue from different ad placements (pre-roll, mid-game,
            post-game, rewarded ads).
          </p>
          <div className="table-responsive">
            <table
              ref={tableRef}
              className="table table-dark table-striped table-hover w-100"
            />
            {filteredData.length === 0 && (
              <p className="text-center mt-3">No data available.</p>
            )}
          </div>
        </div>
      </div>

      {/* Chart Card */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h6 className="mb-3">Earnings by Placement</h6>
          <Bar data={chartData} options={chartOptions} />
        </div>
      </div>
    </DashboardLayout>
  );
}

export default AdPlacementPerformance;
